import { useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import CommonDocumentsGrid from "../../../../components/common/DocumentsGrid/CommonDocumentsGrid";
import { useGetAssociationDocumentsQuery, useLazyViewAssociationsFileQuery } from "../associationApi";
import { useState } from "react";
import DocumentUploadSection from "../../../order/modal/UploadDocumentModal";
import MultiSelectDocModal from "../../../../components/common/DocumentsGrid/Modal/MultiSelectDocModal";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const AssociationDocumentsForm = () => {

    const { associationId } = useParams();
    const [viewFile] = useLazyViewAssociationsFileQuery();
    const [showUploadDocModal, setShowUploadDocModal] = useState(false);
    const [showMultiDocSelectModal, setShowMultiDocSelectModal] = useState(false);

    const {
        data: documentsData,
    } = useGetAssociationDocumentsQuery(associationId || skipToken);

    const handleViewDownloadFile = async ({
        id,
        shouldOpen,
        isDownload,
    }: {
        id: string;
        shouldOpen: boolean;
        isDownload: boolean
    }) => {
        viewFile({ fileId: id, isDownload: isDownload, isOpenInFrame: shouldOpen });
    };

    return (
        <>
            <CommonDocumentsGrid
                data={documentsData}
                title="Documents"
                count={documentsData?.length}
                hasAddPermission={true}
                hasSortPermission={false}
                companyId={associationId}
                onClick={handleViewDownloadFile}
                setShowUploadDocModal={setShowUploadDocModal}
                setShowMultiDocSelectModal={setShowMultiDocSelectModal}
                addPermission={hasPermission(["ASSOC-U"])}
            />
            {
                showUploadDocModal &&
                <DocumentUploadSection show={showUploadDocModal} setShow={setShowUploadDocModal}
                    relationalId={associationId} tgxFileType={"ASSOCIATION_FILE"}

                />
            }

            {
                showMultiDocSelectModal && (
                    <MultiSelectDocModal show={showMultiDocSelectModal}
                        setShow={setShowMultiDocSelectModal}
                       
                    />
                )
            }

        </>
    );
};

export default AssociationDocumentsForm;
